export enum Capabilities {
  /** Determines whether the teacher view displays the five day planner */
  FiveDayPlanner = 'FiveDayPlanner',
  /** Determines whether the teacher view displays the legacy style view with left nav */
  LegacySupplemental = 'LegacySupplemental',
  /** Determines if classroom product has Supplemental settings */
  SupplementalClassSettings = 'SupplementalClassSettings',
  /** Determines whether the teacher view displays the Lesson page */
  LessonPage = 'LessonPage',
  /** Determines whether the teacher view displays the Materials page */
  MaterialsPage = 'MaterialsPage',
  /** Determines whether the lesson page has a button for the teacher guide ebook */
  TeacherGuideButton = 'TeacherGuideButton',
  /** Determines whether the teacher view displays the weekly planner */
  WeeklyPlanner = 'WeeklyPlanner',
  /** Determines whether the Materials page displays the ebook launch type component. */
  MaterialsEbook = 'MaterialsEbook',
  /** Flag to show student dashboard left topic navigation */
  TopicNavigation = 'TopicNavigation',
  /** Flag to enable the Blob avatar and stickers for the student dashboard */
  BlobAvatar = 'BlobAvatar',
  /** Flag to enable the superkids student dashboard */
  SKOF = 'SKOF',
  /** Flag to enable the quest on the student dashboard */
  QuestDashboard = 'QuestDashboard',
  /** Flag to enable the Independent Work classroom reports */
  IndependentWorkReports = 'IndependentWorkReports',
  /** Flag to enable the Quest classroom reports */
  QuestReports = 'QuestReports',
  /** Flag to enable the classroom Progress reports */
  ProgressReports = 'ProgressReports',
  /** Flag to enable student navigation based on biomes */
  BiomeNavigation = 'BiomeNavigation',
  /** Determines if classroom product can have its Topic manually unlocked */
  UnlockTopicSetting = 'UnlockTopicSetting',
  /** Determines if classroom's students can customize their avatar */
  AvatarCustomizationSetting = 'AvatarCustomizationSetting',
  /** Determines if Quests can be hidden from students in Student Portal */
  HideQuestSetting = 'HideQuestSetting',
  /**  Flag for showing or hiding the student objectives list on the right side of the Lesson Page */
  StudentObjectives = 'StudentObjectives',
  /** Determines if the classroom product uses the Custom Free-Write (Manuscript) quest activity type. */
  CustomFreeWriteQuestManuscript = 'CustomFreeWriteQuestManuscript',
  /** Determines if the classroom product uses the Custom Free-Write (Cursive) quest activity type. */
  CustomFreeWriteQuestCursive = 'CustomFreeWriteQuestCursive',
  /** Determines if the classroom product needs addition of Unit to the Topic Name. */
  AddUnitToTopicName = 'AddUnitToTopicName',
  /** Determines if a Digital Admin has access to Benchmark Reports for a product */
  BenchmarkReports = 'BenchmarkReports',
  /** Determines if Digital Admin has access to StandardsOverTime admin report */
  StandardsOverTimeReport = 'StandardsOverTime',
  /** Determines if Digital Admin has access to StandardsDetail admin report */
  StandardsDetailReport = 'StandardsDetail',
  /** Determines if a Digital Admin has access to the Skills Average Report for a product */
  SkillsAverageReport = 'SkillsAverageReport',
  /** Determines if a Digital Admin has access to the Class Comparison Report for a product */
  ClassComparisonReport = 'ClassComparisonReport',
  /** Flag to indicate that this product is an add-on to a parent product  */
  AddOnProduct = 'AddOnProduct',
  /** Flag to indicate that this product has multiple products within a main product.  */
  ProductSubsections = 'ProductSubsections',
  /** Flag to indicate that the Teacher or Digital Admin can use heatmap reports */
  HeatmapReport = 'HeatmapReport',
  /** Flag to indicate that this product has component subsections.  */
  ComponentSubsections = 'ComponentSubsections',
  /** Flag to indicate that this product’s individual material pages can be displayed in a thumbnail view. */
  MaterialThumbnailView = 'MaterialThumbnailView',
  /** Determines if Retrospective can be enabled/disabled for this product. */
  RetrospectiveSettings = 'RetrospectiveSettings',
  /** Determines if the classroom product can have focus mode enabled. */
  FocusMode = 'FocusMode',
  /** Determines if the classroom product has quests configured by activity */
  ActivityConfiguredQuest = 'ActivityConfiguredQuest',
  /** Determines if the product uses seat-based licenses */
  SeatBasedLicense = 'SeatBasedLicense',
  /** Determines if a Product is available in the Resource Repository. */
  ResourceRepository = 'ResourceRepository'
}
